export const PUBLIC_UPDATE = 'PUBLIC_UPDATE';
export const PUBLIC_UPDATE_REQUESTED = 'PUBLIC_UPDATE_REQUESTED';
export const PUBLIC_UPDATE_FAILED = 'PUBLIC_UPDATE_FAILED';
